import api, { googleApi } from "./httpClientInstance";
import API_ENDPOINTS from "../config/Endpoints";


/**
 * Fetches featured properties
 */
export const fetchFeaturedProperties = async (params = {}) => {
    const data = await api.get(API_ENDPOINTS.FEATURED_PROPERTIES, { params });
    return data;
};

/**
 * Fetches recommended properties (personalized, requires login)
 */
export const fetchRecommendedProperties = async (params = {}) => {
    const data = await api.get(API_ENDPOINTS.RECOMMENDED_PROPERTIES, { params });
    return data;
};

/**
 * Fetches builder projects + city_counts for the Cities section
 */
export const fetchHomeProjectData = async (params = {}) => {
    const data = await api.get(API_ENDPOINTS.HOME_PROJECT_DATA, { params });
    return data;
};

/**
 * Fetches offers for the home page
 */
export const fetchOffers = async (params = {}) => {
    const data = await api.get(API_ENDPOINTS.OFFERS_HOME, { params });
    return data;
};


/**
 * Fetches city name from coordinates using Google Maps Geocoding API
 */
export const fetchCityFromCoordinates = async ({ latitude, longitude }) => {
    const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    const response = await googleApi.get(
        API_ENDPOINTS.CITY_FROM_COORDINATES,
        {
            params: {
                latlng: `${latitude},${longitude}`,
                key: GOOGLE_MAPS_API_KEY,
            },
        }
    );

    if (response.data.status === "OK") {
        const addressComponents = response.data.results[0]?.address_components;
        const city = addressComponents?.find((component) =>
            component.types.includes("locality")
        );
        const state = addressComponents?.find((component) =>
            component.types.includes("administrative_area_level_1")
        );
        return { city: city?.long_name || null, state: state?.long_name || null };
    }

    return null;
};